(function () {
  function initProduct(section) {
    if (!section || section.dataset.productInitialized) return;
    section.dataset.productInitialized = 'true';
    var form = section.querySelector('[data-product-form]');
    var select = section.querySelector('[data-variant-select]');
    var variantsNode = section.querySelector('[data-product-variants]');
    if (!form || !variantsNode) return;
    var variants;
    try {
      variants = JSON.parse(variantsNode.textContent).reduce(function (map, variant) {
        map[String(variant.id)] = variant;
        return map;
      }, {});
    } catch (error) { return; }
    var price = section.querySelector('[data-product-price]');
    var variantId = form.querySelector('[data-variant-id]');
    var submit = form.querySelector('[data-add-to-cart]');
    var note = section.querySelector('[data-variant-note]');
    var soldOutMessage = section.querySelector('[data-sold-out-message]');
    var bisHook = section.querySelector('[data-bis-hook]');
    var restockVariantInput = section.querySelector('#restock-variant-change');
    function update(variant) {
      if (!variant) return;
      var available = Boolean(variant.available);
      variantId.value = variant.id;
      if (price && select && select.options[select.selectedIndex]) price.textContent = select.options[select.selectedIndex].dataset.price;
      if (submit) {
        submit.disabled = !available;
        submit.setAttribute('aria-disabled', String(!available));
        submit.textContent = available ? submit.dataset.addLabel : submit.dataset.soldOutLabel;
      }
      if (soldOutMessage) soldOutMessage.hidden = available;
      if (note) note.textContent = available ? '' : section.dataset.unavailableLabel;
      if (bisHook) {
        bisHook.hidden = available;
        bisHook.dataset.bisVariantId = variant.id;
        bisHook.dataset.bisVariantTitle = variant.title;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (restockVariantInput) {
        restockVariantInput.value = variant.id;
        restockVariantInput.dispatchEvent(new Event('input', { bubbles: true }));
        restockVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (select) select.addEventListener('change', function () { update(variants[String(select.value)]); });
    form.addEventListener('submit', function (event) {
      var variant = variants[String(variantId.value)];
      if (!variant || !variant.available) event.preventDefault();
    });
    update(variants[String(variantId.value)]);
  }
  function boot() { document.querySelectorAll('[data-product-section]').forEach(initProduct); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (event) { initProduct(event.target); });
}());
